<template>
    <div class="window-wrapper" v-if="showTrialWindow">
        <div class="window demo-notice-window" v-if="showTrialWindow">
            <div class="window-head">
                <div class="title">Добро пожаловать!
                    <span class="close"><img src="@/image/close.png"
                                             @click="closeWindow"></span>
                </div>
            </div>
            <div class="window-body">
                <div class="text">Вам подключен пробный период на <span v-html="formattedDaysLeft"/>.<br>Оцените все
                    возможности платного
                    тарифа!
                </div>
                <div class="center">
                    <button class="button blue-button" type="button"
                            @click="closeWindow">Ок
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import * as Cookies from 'js-cookie';

    export default {
        name: "TrialWindow",

        data() {
            return {
                formattedDaysLeft: '7 дней'
            }
        },

        computed: {
            showTrialWindow: {
                get() {
                    return this.$store.getters.showTrialWindow;
                },

                set(val) {
                    this.$store.dispatch('setShowTrialWindow', val);
                    utils.changePopupWindowVisibility(val);
                }
            },

            currentUserEmail() {
                return this.$store.getters.currentUser.email;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            }
        },

        watch: {
            currentUserEmail(val) {
                this.showWindow();
            }
        },

        mounted() {
            this.showWindow();
        },

        methods: {
            async showWindow() {
                if (!this.currentUserEmail)
                    return;

                let trialWindowEmail = Cookies.get(constants.TRIAL_WINDOW_EMAIL_COOKIE_NAME);
                if (!!trialWindowEmail && trialWindowEmail === this.currentUserEmail)
                    return;

                Cookies.set(constants.TRIAL_WINDOW_EMAIL_COOKIE_NAME, this.currentUserEmail, {expires: 365});

                let subscription = this.currentSubscription;
                if (!subscription)
                    subscription = await this.$store.dispatch('getCurrentSubscription');
                if (!!subscription && !!subscription.trial) {
                    let daysInclined = utils.inclineNumeral(subscription.daysLeft, ['день', 'дня', 'дней']);
                    this.formattedDaysLeft = `${subscription.daysLeft}&nbsp;${daysInclined}`;

                    this.showTrialWindow = true;
                }
            },

            closeWindow() {
                this.showTrialWindow = false;
            }
        },

        destroyed() {
            utils.changePopupWindowVisibility(false);
        }
    }
</script>